import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-love",
  "use": "icon-love-usage",
  "viewBox": "0 0 14 13",
  "content": "<symbol viewBox=\"0 0 14 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-love\">\n<path d=\"M9.71678 1.46552C7.07894 1.46552 6.74892 3.65908 6.74892 3.65908C6.74892 3.65908 6.42009 1.46552 3.78225 1.46552C1.24522 1.46552 0.505955 4.13772 0.815582 5.56642C1.63166 9.34262 6.74892 11.9884 6.74892 11.9884C6.74892 11.9884 11.8674 9.34262 12.6834 5.56642C12.9919 4.13772 12.2514 1.46552 9.71678 1.46552Z\" stroke=\"black\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol